export default [
  // DPT
  {
    path: "/data-dpt",
    component: () => import("@/pages/dpt/dpt-list.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  // Pendukung
  {
    path: "/data-pendukung",
    component: () => import("@/pages/pendukung/pendukung-list.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan"],
    },
  },
  {
    path: "/data-pendukung/manual/",
    component: () => import("@/pages/pendukung/pendukung-manual.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan"],
    },
  },
  {
    path: "/data-pendukung/detail/:id",
    component: () => import("@/pages/pendukung/pendukung-detail.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan"],
    },
  },
  {
    path: "/data-pendukung/dpt/:id",
    component: () => import("@/pages/pendukung/pendukung-form.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan"],
    },
  },
  {
    path: "/data-pendukung/update/:id",
    component: () => import("@/pages/pendukung/pendukung-update.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes", "relawan"],
    },
  },
  // Saksi
  {
    path: "/data-saksi",
    component: () => import("@/pages/saksi/saksi-list.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  {
    path: "/data-saksi/manual/",
    component: () => import("@/pages/saksi/saksi-manual.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  {
    path: "/data-saksi/set/:id",
    component: () => import("@/pages/saksi/saksi-form.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  // Relawan
  {
    path: "/data-relawan",
    component: () => import("@/pages/relawan/relawan-list.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  {
    path: "/data-relawan/set/:id",
    component: () => import("@/pages/relawan/relawan-form.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  // Master
  {
    path: "/master/dapil/",
    component: () => import("@/pages/master/dapil-list.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/master/dapil/detail/:id",
    component: () => import("@/pages/master/dapil-detail.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/master/target/",
    component: () => import("@/pages/master/target-list.vue"),
    meta: {
      requiredLevel: ["admin"],
    },
  },
  {
    path: "/master/tim/",
    component: () => import("@/pages/master/tim-list.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam", "kordes"],
    },
  },
  // Rekap
  {
    path: "/rekap/pendukung/",
    component: () => import("@/pages/rekap/rekap-list.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam"],
    },
  },
  {
    path: "/rekap/pendukung/kabupaten/:id",
    component: () => import("@/pages/rekap/rekap-kabupaten.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam"],
    },
  },
  {
    path: "/rekap/pendukung/kecamatan/:id",
    component: () => import("@/pages/rekap/rekap-kecamatan.vue"),
    meta: {
      requiredLevel: ["admin", "korwil", "korcam"],
    },
  },
  // Quick Count
  {
    path: "/quick-count",
    component: () => import("@/pages/quick-count/quickcount-list.vue"),
    meta: {
      requiredLevel: ["admin", "kordes"],
    },
  },
  {
    path: "/quick-count/create",
    component: () => import("@/pages/quick-count/quickcount-form.vue"),
    meta: {
      requiredLevel: ["admin", "kordes", "korcam", "korwil"],
    },
  },
  {
    path: "/quick-count/update/:id",
    component: () => import("@/pages/quick-count/quickcount-update.vue"),
    meta: {
      requiredLevel: ["admin", "kordes", "korcam", "korwil"],
    },
  },
];
